import { composeIO } from 'react-compose-io'
import { iniciarNovoCicloIO } from './IniciarNovoCiclo.IO'
import { IniciarNovoCicloView } from './IniciarNovoCiclo.View'

export const IniciarNovoCiclo = composeIO(IniciarNovoCicloView, iniciarNovoCicloIO)
